@let PADDING = 40;
@let FONT = '36px DINRoundPro';

<div class="ease-out-back grid place-items-center transition-all" [style.width.px]="shown()?.k ?? '' | textWidth: FONT : PADDING">
  <!-- spacer (so the element has width and height) -->
  <div class="font-family-din pointer-events-none invisible w-full rounded-sm border-2 p-4 text-4xl select-none">
    {{ shown()?.k }}
  </div>

  <!-- actual element -->
  @for (current of [shown()]; track current?.id) {
    <div
      class="border-surface-300 font-family-din text-text-primary absolute w-full cursor-pointer rounded-sm border-2 bg-white p-4 text-center text-4xl transition-transform select-none hover:-translate-y-1"
      [style.width.px]="current?.k ?? '' | textWidth: FONT : PADDING"
      animate.enter="wait-500 klank-enter"
      animate.leave="klank-leave"
    >
      {{ shown()?.k }}
    </div>
  }
</div>
